import React from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ align: [] }],
        [{ direction: "rtl" }],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
        ],
        ["link", "image"],
        ["clean"],
    ],
};

const formats = [
    "header",
    "align",
    "direction",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
];
const QuillEditor = ({ value, setValue }) => {
    return (
        <ReactQuill
            style={{
                overflowY: "auto",

                maxHeight: "380px",
                marginBottom: "10px",
            }}
            modules={modules}
            formats={formats}
            theme="snow"
            value={value}
            onChange={setValue}
        />
    );
};

export default QuillEditor;
